import React, { Component } from "react";
import CreateInvoice from "../fragments/create-invoice";
import { Link, browserHistory } from "react-router";
import UserCard from "../fragments/user-card";
import AdminNotifaction from "../fragments/admin-notifaction";

import trAccStore from "../../store/transaction-account-store";
import swipeStore from "../../store/swipe-machine-store";
import invoiceStore from "../../store/invoice-store";
import shiftStore from "../../store/shift-store";
import mpdStore from "../../store/mpd-store";
import tankStore from "../../store/tank-store";
import nozzelStore from "../../store/nozzel-store";
import expenditureCatagoryStore from "../../store/expenditure-catagory-store";
import PaymentModeStore from "../../store/payment-mode-store";

import { invoiceConstant, notificationConstant } from "../../constants/constants";
import MessageBox from "../utility/message-box";
import QuestionBox from "../utility/question-box";
import Spinner from "../utility/spinner";
import * as productAction from "../../actions/product-action";
import * as tankAction from "../../actions/tank-action";
import * as mpdAction from "../../actions/mpd-action";
import * as shiftAction from "../../actions/shift-action";
import * as notificationAction from "../../actions/notification-action";
import notificationStore from "../../store/notification-store";
import * as expenditureCatagoryAction from "../../actions/expenditure-catagory-action";
import * as transactionAccountAction from "../../actions/transaction-account-action";
import * as swipeMachineAction from "../../actions/swipe-machine-action";
import { Motion, spring } from "react-motion";
import * as PaymentModeAction from "../../actions/payment-mode-action";
import AutoComplete from "../utility/auto-complete";
import { toExactFixted, DD_MM_YY, } from "../utility/util-methods";
import rq from "../utility/rq.js";
import CurrencyEntry from "../fragments/currency-entry";
import authStore from "../../store/auth-store";
//import CurrentCredit from "../fragments/current-credit";
import NetDetect from "../utility/net-detect";

class Master1 extends Component {

    constructor() {
        super();
        this.stockIn = null;
        this.state = {
            spinner: false,
            lastShiftData: {},
            creditData: [],
            productDetail: [],
            shiftDetail: null,
            tankDetail: [],
            showRightPannel: false,
            showCurrencyForm: false,


            gotCreditData: false,
            gotTankData: false,

        };

        this.questionBox = null;
        this.messageBox = null;
        // this.onCreated = this.onCreated.bind(this);
        // this.onFailed = this.onFailed.bind(this);
        this.currencyFormReset = false;
        this.hideSpinner = this.hideSpinner.bind(this);
        this.showSpinner = this.showSpinner.bind(this);

    }

    showSpinner() {
        this.setState({ spinner: true });
    }

    hideSpinner() {
        this.setState({ spinner: false });
    }

    cancelAllCards() {
        this.adminNotification = null;
        this.userCard = null;
        this.stockIn = null;

    }

    // onFailed(msg) {
    //     this.messageBox = MessageBox.showMessage(msg, false, this);
    //     this.hideSpinner();
    //     this.setState(this.state);
    // }
    // onCreated(msg) {
    //     this.messageBox = MessageBox.showMessage(msg, true, this);
    //     this.hideSpinner();
    // }


    onNotificationFetched() {
        this.forceUpdate();
    }

    onMouseEnter(subMenuName) {
        this.adminNotification = null;
        //hiding the notifiaction box        
        this.setState({ submenus: { [subMenuName]: true } });
    }

    onCurrencySave(currencyData, cashInTotal, cashOutTotal) {
        if (cashInTotal === cashOutTotal && (cashInTotal || cashOutTotal)) {
            var myCashData = {
                exchangeId: 1,
                cashInTotal,
                cashOutTotal,
                currencyData,
                comment: "",
            };
            this.setState({ spinner: true });
            rq.postJson("/api/v1/cash-exchange", myCashData).then(() => {
                this.messageBox = MessageBox.showMessage("Cash Exchange Successfull", true, this);
                this.currencyFormReset = true;
                this.setState({ showCurrencyForm: false, spinner: false });
            }).catch(() => {
                this.messageBox = MessageBox.showMessage("Cash Exchange Failed", false, this);
                this.forceUpdate();
            });

        } else {
            this.messageBox = MessageBox.showMessage("Cash In and Cash Out must be same amount", false, this);
            this.forceUpdate();
        }
    }

    onCurrencyCancel() {
        this.setState({ showCurrencyForm: false });
    }

    loadPannelData() {
        rq.getJsonData("/api/v1/mis/last-running-shift").then((data) => {
            this.setState({ lastShiftData: data[0], tankDetail: [], shiftDetail: null });
        }).catch((err) => {
            console.error(err);
        });

        rq.getJsonData("/api/v1/shiftdetail").then((data) => {
            this.setState({ lastShiftData: {}, shiftDetail: data[0] });
        }).catch((err) => {
            console.error(err);
        });

        rq.getJsonData("/api/v1/tank/current-shift-tank-detail").then((data) => {
            //console.log(data);
            this.setState({ tankDetail: data, gotTankData: true });

        }).catch((err) => {
            console.error(err);
        });

        rq.getJsonData("/api/v1/current-shift-product-rate").then((data) => {
            this.setState({ productDetail: data[0], gotShiftData: true });
        }).catch((err) => {
            console.error(err);
        });

        // rq.getJsonData("/api/v1/credit-report-by-shift").then((data) => {
        //     this.setState({ creditData: data, gotCreditData: true });
        // }).catch((err) => {
        //     throw err;
        // });
    }




    handleAvailableCashClick() {
        //this.setState({ avilableCashSpinner: true });
        this.setState({ showCurrencyForm: true });
    }
    currencyFailed() {
        this.setState({ showCurrencyForm: false });
    }
    askQuestion(msg, yesCallBack, noCallBack) {
        this.questionBox = (<QuestionBox questionMsg={msg} yesCallBack={yesCallBack} noCallBack={noCallBack}></QuestionBox>);
        this.setState(this.state);
    }

    toggleRightPannel() {
        //console.log("called");
        if (!this.state.showRightPannel) {
            this.loadPannelData();
        }
        this.setState({ showRightPannel: !this.state.showRightPannel, gotCreditData: false, gotTankData: false });
    }
    componentDidUpdate() {
        this.currencyFormReset = false;
    }
    componentWillMount() {
        this.loadPannelData();
    }
    render() {
        return (
            <div>
                {this.messageBox}
                {this.questionBox}
                {this.state.spinner ? <Spinner /> : null}
                <Header></Header>
                {/* <CurrentCredit></CurrentCredit> */}

                {this.props.children}

                <div id="slideBox" style={{ transition: "all .2s ease-in", width: "400px", alignItems: "end", position: "fixed", right: this.state.showRightPannel ? 0 : "-402px", top: "45px" }}>

                    <i onClick={this.toggleRightPannel.bind(this)} className={"rightArrow fa boxShadow " + (this.state.showRightPannel ? "fa-arrow-right" : "fa-arrow-left")}></i>
                    <i onClick={this.toggleRightPannel.bind(this)} className={"rightArrow fa boxShadow " + (this.state.showRightPannel ? "fa-arrow-right" : "fa-arrow-left")}></i>


                    {this.state.shiftDetail ?
                        <div style={{ display: "flex", backgroundColor: "rgb(247, 57, 136)", marginBottom: "15px", color: "#ffffff", position: "relative" }} className="boxShadow">
                            <table className="homePageTable" style={{ width: "250px", margin: "5px auto 5px auto" }} >
                                <tbody>
                                    <tr>
                                        <td >
                                            Shift Date :
                                        </td>
                                        <td >
                                            {DD_MM_YY(this.state.shiftDetail.shiftDate)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td >
                                            Current Shift :
                                        </td>
                                        <td >
                                            {this.state.shiftDetail.shiftName}
                                        </td>
                                    </tr>
                                    {this.state.productDetail.length > 0 ?
                                        this.state.productDetail.map((product, i) => {
                                            return (
                                                <tr key={i}>
                                                    <td >
                                                        {product.productName}:
                                                    </td>
                                                    <td >
                                                        ₹ {toExactFixted(product.sellingPrice, 2)}
                                                    </td>
                                                </tr>
                                            );
                                        })
                                        : null}
                                </tbody>
                            </table>

                        </div>
                        : <div style={{ display: "flex", flexDirection: "column", height: "200px", justifyContent: "center", alignItems: "center", backgroundColor: "rgb(247, 57, 136)", marginBottom: "15px", color: "#ffffff", position: "relative" }}>
                            <h2 style={{ fontSize: "1.2em" }}>No shift is running !!!</h2>
                            <br />
                            <p>Last Shift Date <span> {DD_MM_YY(this.state.lastShiftData.shiftDate)}</span></p>
                            <p>Shift Name <span>{this.state.lastShiftData.shiftName}</span></p>
                        </div>
                    }
                    {this.state.tankDetail.length > 0 ?
                        <div style={{ display: "flex", overflow: "auto", backgroundColor: "rgb(247, 57, 136)", marginBottom: "15px", color: "#ffffff", position: "relative" }} className="boxShadow">

                            <table className="homePageTable" id="centerTd">
                                <tbody>
                                    <tr>
                                        <th >
                                            Tank Name
                                        </th>
                                        <th >
                                            Product
                                        </th>
                                        <th >
                                            O-dip
                                        </th>
                                        <th >
                                            Volume
                                        </th>
                                        <th>Stock In</th>
                                        <th>Available</th>
                                    </tr>
                                    {this.state.tankDetail.map((tank, i) => {
                                        return (<tr key={i}>
                                            <td>
                                                {tank.tankName}
                                            </td>
                                            <td>
                                                {tank.productName}
                                            </td>
                                            <td>
                                                {tank.dip}
                                            </td>
                                            <td>
                                                {tank.volume}
                                            </td>
                                            <td>{tank.stockInAmount}</td>
                                            <td>{tank.avilable}</td>
                                        </tr>
                                        );

                                    })}
                                </tbody>
                            </table>
                            <i className="fa fa-spin fa-spinner" style={{ position: "absolute", top: "40px", left: "200px", fontSize: "2em", display: !this.state.gotTankData ? "inline-block" : "none" }}></i>
                        </div>
                        : null}
                    {this.state.creditData.length > 0 ?
                        <div id="creditHolder" style={{ position: "relative", display: "flex", maxHeight: "200px", overflow: "auto", backgroundColor: "rgb(247, 57, 136)", marginBottom: "15px", color: "#ffffff" }}>
                            <table className="homePageTable" id="centerTd">
                                <tbody>
                                    <tr>
                                        <th >
                                            Creditor Name
                                        </th>
                                        <th >
                                            Product
                                        </th>
                                        <th >
                                            Quantity
                                        </th>
                                        <th >
                                            Amount
                                        </th>
                                    </tr>
                                    {this.state.creditData.map((e, i) => {
                                        return (<tr key={i}>
                                            <td>
                                                {e.firmName}
                                            </td>
                                            <td>
                                                {e.productName}
                                            </td>
                                            <td>
                                                {e.quantitys}
                                            </td>
                                            <td>
                                                {e.amount}
                                            </td>

                                        </tr>
                                        );

                                    })}
                                </tbody>
                            </table>
                            <i className="fa fa-spin fa-spinner" style={{ position: "absolute", top: "100px", left: "200px", fontSize: "2em", display: !this.state.gotTankData ? "inline-block" : "none" }}></i>
                        </div>
                        : null}



                </div>

                <div style={{ transition: "all .3s ease-in", position: "fixed", right: "10px", transform: this.state.showCurrencyForm ? "scale(0)" : "scale(1)" }} className="boxShadow availableCash" onClick={this.handleAvailableCashClick.bind(this)}>
                    <i className="fa fa-inr"></i>
                </div>

                <CurrencyEntry
                    visible={this.state.showCurrencyForm}
                    onSave={this.onCurrencySave.bind(this)}
                    onCancel={this.onCurrencyCancel.bind(this)}
                    reset={this.currencyFormReset}
                    onFailed={this.currencyFailed.bind(this)}
                >
                </CurrencyEntry>

            </div>
        );
    }
}





class Header extends React.Component {

    constructor() {
        super();
        this.createInvoice = null;
        this.adminNotification = null;
        this.userCard = null;
        this.stockIn = null;

        this.state = {
            allLinks: [
                //---------- cash sub menu --------
                { linkName: " create new currency", linkAddress: "/page/create-currency" },
                { linkName: "  exchange  entry", linkAddress: "/page/exchange" },
                // --------- Employee sub menu --------------
                { linkName: " create new employee", linkAddress: "/page/create-employee" },
                { linkName: " employee advance payment", linkAddress: "/page/employee-advance" },
                { linkName: " collect cash from employee", linkAddress: "/page/employee-cash-collection" },
                { linkName: " employee edit", linkAddress: "/edit-page/employee" },
                { linkName: " employee advance between two day", linkAddress: "/report/employee-advance-between-two-day" },
                { linkName: "  current shift employe advance", linkAddress: "/report/current-shift-employee-advance" },
                { linkName: " salary payment by date", linkAddress: "/report/salary-payment-by-date" },
                { linkName: "  employee attendance shortage report", linkAddress: "/report/employee-attendance-shortage" },
                { linkName: "  employee salary report", linkAddress: "/report/employee-salary-detail" },
                // ............. Credito sub menu .......
                { linkName: "  create new creditor", linkAddress: "/page/create-creditor" },
                { linkName: " credit entry", linkAddress: "/page/credit-entry" },
                { linkName: " credit payment entry", linkAddress: "/page/creditor-payment-entry" },
                { linkName: "  creditor edit", linkAddress: "/edit-page/creditor" },
                { linkName: " current shift  credit report", linkAddress: "/report/current-shift-credit-report" },
                { linkName: "  credit detail between two day", linkAddress: "/report/credit-detail-between-two-day" },
                { linkName: " credit payment between two day", linkAddress: "/report/credit-payment-between-two-day" },
                { linkName: " credit unbilled report of  all parties", linkAddress: "/report/credit-report-unbilled" },
                { linkName: "    credit billed report of  all parties", linkAddress: "/report/credit-report-billed" },
                { linkName: "  credit billed report by creditor", linkAddress: "/report/credit-report-billed-by-id" },
                { linkName: "   payment report by creditor name", linkAddress: "/report/credit-payment-by-credit-id" },
                { linkName: "   current shift detail credit report", linkAddress: "/report/current-shift-detail-credit-report" },
                { linkName: " sell report", linkAddress: "/report/sell" },
                { linkName: "   date wise sell report", linkAddress: "/report/sell-day" },
                { linkName: "   reading report", linkAddress: "/report/reading-report" },
                { linkName: "   credit report with aggreagation", linkAddress: "/report/credit-report-by-shift-with-aggreagation" },
                { linkName: "   credit statement of all parties", linkAddress: "/report/credit-statement" },
                { linkName: "  credit account details", linkAddress: "/report/credit-account-details" },
                { linkName: "    current shift cash collection", linkAddress: "/report/current-shift-cash-collection" },

                //----------------------- expenditure sub menu -------------------

                { linkName: "       Expenditure Detail Entry", linkAddress: "/page/expenditure-detail" },
                { linkName: "      Current Shift Expenditure  report", linkAddress: "/report/current-shift-expenditure" },
                { linkName: "    Expenditure between two day", linkAddress: "/report/expenditure-between-two-day" },
                { linkName: "      Expenditure With Aggreagation", linkAddress: "/report/expenditure-between-two-day-with-aggreagation" },
                { linkName: "   Reading Report", linkAddress: "/report/reading-report" },
                { linkName: "   Reading Report", linkAddress: "/report/reading-report" },
                { linkName: "   Reading Report", linkAddress: "/report/reading-report" },
                { linkName: "   Reading Report", linkAddress: "/report/reading-report" },
                { linkName: "   Reading Report", linkAddress: "/report/reading-report" },
                { linkName: "   Reading Report", linkAddress: "/report/reading-report" },


            ],
            spinner: false,
            submenus: {
                cash: false,
                employee: false,
                creditor: false,
                product: false,
                expenditure: false,
                shift: false,
                admin: false
            },
            lastShiftData: {},
            creditData: [],
            productDetail: [],
            shiftDetail: null,
            tankDetail: [],
            showRightPannel: false,
            showCurrencyForm: false,
            searchMode: false,

            gotCreditData: false,
            gotTankData: false,

        };
        this.hideSpinner = this.hideSpinner.bind(this);
        this.showSpinner = this.showSpinner.bind(this);
        this.createInvoiceCancel = this.createInvoiceCancel.bind(this);
        this.questionBox = null;
        this.messageBox = null;
        this.onCreated = this.onCreated.bind(this);
        this.onFailed = this.onFailed.bind(this);
        this.onNotificationFetched = this.onNotificationFetched.bind(this);
        this.seleteLink = this.seleteLink.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.currencyFormReset = false;
        this.user = authStore.getToken().user;
        this.styles = {
            menuHeader: {
                margin: "0 0 0 -15px",
                color: "#23b9fd",
                fontSize: "16px"
            }
        };
    }

    showSpinner() {
        this.setState({ spinner: true });
    }

    hideSpinner() {
        this.setState({ spinner: false });
    }

    cancelAllCards() {
        this.adminNotification = null;
        this.userCard = null;
        this.stockIn = null;

    }
    handleCreateInvoive() {
        this.createInvoice = (<CreateInvoice
            hide={this.createInvoiceCancel}
            showSpinner={this.showSpinner}
            hideSpinner={this.hideSpinner}
        />);
        this.forceUpdate();
    }

    cancelAdminNotification() {
        this.adminNotification = null;
        this.forceUpdate();
    }

    handleAdminNotification() {
        notificationAction.getAllNotification();
        if (this.adminNotification) {
            this.adminNotification = null;
        } else {
            this.cancelAllCards();
            this.adminNotification = <AdminNotifaction hide={this.cancelAdminNotification.bind(this)}></AdminNotifaction>;
        }
        this.forceUpdate();
    }

    createInvoiceCancel() {
        this.createInvoice = null;
        this.forceUpdate();
    }
    handleUserCard() {
        if (this.userCard) {
            this.userCard = null;
        } else {
            this.cancelAllCards();
            this.userCard = <UserCard></UserCard>;
        }

        this.forceUpdate();
    }


    onCreated(msg) {
        this.messageBox = MessageBox.showMessage(msg, true, this);
        this.hideSpinner();
        this.createInvoiceCancel();
    }
    onFailed(msg) {
        this.messageBox = MessageBox.showMessage(msg, false, this);
        this.hideSpinner();
        this.setState(this.state);
    }
    onNotificationFetched() {
        this.forceUpdate();
    }

    onMouseEnter(subMenuName) {
        this.adminNotification = null;
        //hiding the notifiaction box        
        this.setState({ submenus: { [subMenuName]: true } });
    }

    onMouseLeave(subMenuName) {
        this.setState({ submenus: { [subMenuName]: false } });
    }

    toggleSubmenu(subMenuName) {
        this.setState({ submenus: { [subMenuName]: !this.state.submenus[subMenuName] } });

    }
    hideSubMenu(subMenuName) {
        this.setState({ submenus: { [subMenuName]: false } });
    }

    seleteLink(linkData) {
        if (linkData) {
            browserHistory.push(linkData.linkAddress);
            this.searchBox.value = "";
        }

    }


    askQuestion(msg, yesCallBack, noCallBack) {
        this.questionBox = (<QuestionBox questionMsg={msg} yesCallBack={yesCallBack} noCallBack={noCallBack}></QuestionBox>);
        this.setState(this.state);
    }
    handleUndoShift() {
        this.askQuestion(`Do you watnt to undo last shift   ?`, () => {
            rq.getJsonData("/api/v1/mis/undo-last-shift").then(() => {
                this.messageBox = MessageBox.showMessage("last shift is undo successfully", true, this);
                this.forceUpdate();
            }).catch((err) => {
                if (err.msg) {
                    this.messageBox = MessageBox.showMessage(err.msg, false, this);
                    this.forceUpdate();
                } else
                    throw err;
            });
            this.questionBox = null;
            this.forceUpdate();

        }, () => {

            this.questionBox = null;
            this.forceUpdate();
        });
    }



    handleSearch() {
        this.searchBox.focus();
        this.setState({ searchMode: !this.state.searchMode });
    }
    onSearchMouseLeave() {
        this.setState({ searchMode: false });
    }


    componentWillMount() {
        // fetching all necessary stores here  instead of home
        productAction.fetchAllProduct();
        tankAction.fetchAllTanks();
        tankAction.fetchAllDipTable();
        mpdAction.fetchAllMpd();
        mpdAction.fetchAllMpdsWithProduct();
        shiftAction.fetchAllShift();
        notificationAction.getAllNotification();
        expenditureCatagoryAction.fetchAllExCat();
        transactionAccountAction.fetchAllTrAccount();
        transactionAccountAction.fetchAllTrAccountPayMode();
        swipeMachineAction.fetchAllSwipes();
        PaymentModeAction.fetchAllPaymentMode();








        invoiceStore.on(invoiceConstant.INVOICE_CREATED, this.onCreated);
        invoiceStore.on(invoiceConstant.INVOICE_CREATION_FAILED, this.onFailed);
        notificationStore.on(notificationConstant.FETCHED_ALL_NOTIFICATION, this.onNotificationFetched);
    }
    componentWillUnmount() {
        invoiceStore.removeListener(invoiceConstant.INVOCE_CREATED, this.onCreated);
        invoiceStore.removeListener(invoiceConstant.INVOICE_CREATION_FAILED, this.onFailed);
        notificationStore.removeListener(notificationConstant.FETCHED_ALL_NOTIFICATION, this.onNotificationFetched);
        //removeListener
    }



    render() {
        return (
            <div>
                {this.createInvoice}
                {this.messageBox}
                {this.questionBox}
                {this.state.spinner ? <Spinner /> : null}
                <div id="headerBar">
                    <div className="leftMenuBar">
                        <ul>
                            <li> </li>
                            <li onMouseEnter={this.onMouseEnter.bind(this, "cash")} onClick={this.toggleSubmenu.bind(this, "swipe")} onMouseLeave={this.onMouseLeave.bind(this, "swipe")}>
                                <i className="IconName" aria-hidden="true" title="Cash">SWIPE</i>
                                {/*----------------------- cash sub menu -------------------*/}

                                <Motion defaultStyle={{ x: 0 }} style={{ x: spring(this.state.submenus.cash ? 1 : 0, { stiffness: 150, damping: 15, precision: 1 }) }}>
                                    {({ x }) => {
                                        return (
                                            <div className="menuHolder"
                                                style={{
                                                    width: "850px",
                                                    height: `${x * 200}px`,
                                                    opacity: `${x}`,

                                                }}>
                                                <div style={{ display: "flex", flex: 1 }}>
                                                    <ul className="submenu">
                                                        <li onClick={this.hideSubMenu.bind(this, "swipe")}>
                                                            <Link to="/report/swipe-ungrouped">
                                                                Swipe UnGroup report
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                        <li onClick={this.hideSubMenu.bind(this, "swipe")}>
                                                            <Link to="/report/swipe-grouped">
                                                                Swipe Group report
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                    </ul>

                                                </div>
                                                <div style={{ height: "20px", background: "#23b9fd", alignSelf: "bottom", margin: "0 -20px" }}></div>
                                            </div>
                                        );
                                    }}
                                </Motion>
                            </li>

                            <li onMouseEnter={this.onMouseEnter.bind(this, "employee")} onClick={this.toggleSubmenu.bind(this, "employee")} onMouseLeave={this.onMouseLeave.bind(this, "employee")}>
                                <i className="IconName" aria-hidden="true" title="Employees">EMPLOYEE</i>

                                {/*----------------------- Employee sub menu -------------------*/}

                                <Motion defaultStyle={{ x: 0 }} style={{ x: spring(this.state.submenus.employee ? 1 : 0, { stiffness: 150, damping: 15, precision: 1 }) }}>

                                    {({ x }) => {

                                        return (
                                            <div className="menuHolder" style={{
                                                width: "850px",
                                                height: `${x * 300}px`,
                                                opacity: `${x}`


                                            }}>
                                                <div style={{ display: "flex", flex: 1 }}>
                                                    <ul className="submenu">
                                                        <p style={this.styles.menuHeader}> New</p>
                                                        <li onClick={this.hideSubMenu.bind(this, "employee")}>
                                                            <Link to="/page/create-employee">Create new e   mployee
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                        <li onClick={this.hideSubMenu.bind(this, "employee")}>
                                                            <Link to="/page/employee-advance">Make Advance Payment
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                        <li onClick={this.hideSubMenu.bind(this, "employee")}>
                                                            <Link to="/report/salary-payment-by-date">
                                                                Salary Payment by Date
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                        <p style={this.styles.menuHeader}>Edit</p>

                                                        <li onClick={this.hideSubMenu.bind(this, "employee")}>
                                                            <Link to="/edit-page/employee">
                                                                Employee Edit
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                    </ul>

                                                    <ul className="submenu">
                                                        <p style={this.styles.menuHeader}>Report</p>
                                                        <li onClick={this.hideSubMenu.bind(this, "employee")}>
                                                            <Link to="/report/employee-advance-between-two-day">
                                                                Employee Advance between two day
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                        <li onClick={this.hideSubMenu.bind(this, "employee")}>
                                                            <Link to="/report/current-shift-employee-advance">
                                                                Current Shift Employee Advance
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>

                                                        <li onClick={this.hideSubMenu.bind(this, "employee")}>
                                                            <Link to="/report/employee-attendance-shortage">
                                                                Employee Attendance Shortage Report
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                        <li onClick={this.hideSubMenu.bind(this, "employee")}>
                                                            <Link to="/report/employee-salary-detail">
                                                                Employee Salary Report
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>

                                                    </ul>
                                                </div>
                                                <div style={{ height: "20px", background: "#23b9fd", alignSelf: "bottom", margin: "0 -20px" }}></div>
                                            </div>);
                                    }}

                                </Motion>

                            </li>

                            <li onMouseEnter={this.onMouseEnter.bind(this, "creditor")} onClick={this.toggleSubmenu.bind(this, "creditor")} onMouseLeave={this.onMouseLeave.bind(this, "creditor")} >
                                <i className="IconName" aria-hidden="true" title="Creditor">CREDIT</i>


                                {/*----------------------- Credito sub menu -------------------*/}

                                <Motion defaultStyle={{ x: 0 }} style={{ x: spring(this.state.submenus.creditor ? 1 : 0, { stiffness: 150, damping: 15, precision: 1 }) }}>
                                    {({ x }) => {
                                        return (
                                            <div className="menuHolder"
                                                style={{
                                                    width: "880px",
                                                    height: `${x * 500}px`,
                                                    opacity: `${x}`

                                                }}>
                                                <div style={{ display: "flex", flex: 1 }}>
                                                    <ul className="submenu">
                                                        <p style={this.styles.menuHeader}> New</p>
                                                        <li onClick={this.hideSubMenu.bind(this, "creditor")}>
                                                            <Link to="/page/create-creditor">
                                                                Create new Creditor
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                        <li onClick={this.hideSubMenu.bind(this, "creditor")}>
                                                            <Link to="/page/credit-entry">Credit Entry
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                        <li onClick={this.hideSubMenu.bind(this, "creditor")}>
                                                            <Link to="/page/creditor-payment-entry">
                                                                Credit Payment Entry
                                                                <span className="line"></span>
                                                            </Link>

                                                        </li>
                                                        <p style={this.styles.menuHeader}>Edit</p>

                                                        <li onClick={this.hideSubMenu.bind(this, "creditor")}>
                                                            <Link to="/edit-page/creditor">
                                                                Creditor Edit
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                        <p style={this.styles.menuHeader}>Credit  Payment Report</p>

                                                        <li onClick={this.hideSubMenu.bind(this, "creditor")}>
                                                            <Link to="/report/credit-payment-between-two-day">
                                                                Credit Payment Between Two dates
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                        <li onClick={this.hideSubMenu.bind(this, "creditor")}>
                                                            <Link to="/report/credit-payment-by-credit-id">
                                                                Credit Payment Report by Creditor
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                    </ul>
                                                    <ul className="submenu">
                                                        <p style={this.styles.menuHeader}>Current Shift Report </p>
                                                        {/* <li onClick={this.hideSubMenu.bind(this, "creditor")}>
                                                    <Link to="/report/current-shift-credit-report">
                                                        Current Shift  Credit Report (grouped)
                                                    <span className="line"></span>
                                                    </Link>
                                                </li> */}
                                                        <li onClick={this.hideSubMenu.bind(this, "creditor")}>
                                                            <Link to="/report/current-shift-detail-credit-report">
                                                                Current Shift Credit Report
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                        <p style={this.styles.menuHeader}>Billed Report</p>

                                                        <li onClick={this.hideSubMenu.bind(this, "creditor")}>
                                                            <Link to="/report/credit-report-unbilled">
                                                                Credit Unbilled Report of  all parties
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                        <li onClick={this.hideSubMenu.bind(this, "creditor")}>
                                                            <Link to="/report/credit-report-billed">
                                                                Credit Billed Report of  all parties
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                        <li onClick={this.hideSubMenu.bind(this, "creditor")}>
                                                            <Link to="/report/credit-report-billed-by-id">
                                                                Credit Billed Report by Creditor
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>


                                                        <p style={this.styles.menuHeader}>Small Creditor</p>

                                                        <li onClick={this.hideSubMenu.bind(this, "creditor")}>
                                                            <Link to="/report/small-creditor-account-statement">
                                                                Small Creditor Account statement
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                        <li onClick={this.hideSubMenu.bind(this, "creditor")}>
                                                            <Link to="/report/all-small-creditor-statement">
                                                                All small creditor statement
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>

                                                        <li onClick={this.hideSubMenu.bind(this, "creditor")}>
                                                            <Link to="/report/all-small-creditor-report-between-two-dates">
                                                                All small creditor report between two dates
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>

                                                    </ul>

                                                    <ul className="submenu">
                                                        <p style={this.styles.menuHeader}>Credit Report</p>
                                                        <li onClick={this.hideSubMenu.bind(this, "creditor")}>
                                                            <Link to="/report/credit-detail-between-two-day">
                                                                Credit Between Two Dates
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                        {/* <li onClick={this.hideSubMenu.bind(this, "creditor")}>
                                                    <Link to="/report/credit-report-by-shift-with-aggreagation">
                                                        Credit Between Two Dates (grouped)
                                                    <span className="line"></span>
                                                    </Link>
                                                </li> */}
                                                        {/* <li onClick={this.hideSubMenu.bind(this, "creditor")}>
                                                    <Link to="/report/credit-statement">
                                                        Credit Statement of all parties
                                                    <span className="line"></span>
                                                    </Link>
                                                </li> */}
                                                        <li onClick={this.hideSubMenu.bind(this, "creditor")}>
                                                            <Link to="/report/credit-account-details">
                                                                Credit Account Details by Croditor
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>

                                                        <li onClick={this.hideSubMenu.bind(this, "creditor")}>
                                                            <Link to="/report/showall-creditors">
                                                                Show All Creditors
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div style={{ height: "20px", background: "#23b9fd", alignSelf: "bottom", margin: "0 -20px" }}></div>
                                            </div>
                                        );
                                    }}


                                </Motion>

                            </li>
                            <li onMouseEnter={this.onMouseEnter.bind(this, "product")} onClick={this.toggleSubmenu.bind(this, "product")} onMouseLeave={this.onMouseLeave.bind(this, "product")} >
                                <i className="IconName" aria-hidden="true" title="product">PRODUCT</i>
                                {/*----------------------- product sub menu -------------------*/}

                                <Motion defaultStyle={{ x: 0 }} style={{ x: spring(this.state.submenus.product ? 1 : 0, { stiffness: 150, damping: 15, precision: 1 }) }}>
                                    {({ x }) => {
                                        return (
                                            <div className="menuHolder"
                                                style={{
                                                    width: "850px",
                                                    height: `${x * 350}px`,
                                                    opacity: `${x}`,

                                                }}>
                                                <div style={{ display: "flex", flex: 1 }}>

                                                    <ul className="submenu">
                                                        <p style={this.styles.menuHeader}>Sell Report</p>
                                                        <li onClick={this.hideSubMenu.bind(this, "product")}>
                                                            <Link to="/report/sell">
                                                                Date wise sell Report
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                        <li onClick={this.hideSubMenu.bind(this, "product")}>
                                                            <Link to="/report/sell-day">
                                                                Date wise sell Report (product)
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                        <li onClick={this.hideSubMenu.bind(this, "product")}>
                                                            <Link to="/report/reading-report">
                                                                Reading Report (Per Day)
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                        <p style={this.styles.menuHeader}>Product</p>
                                                        <li onClick={this.hideSubMenu.bind(this, "product")}>
                                                            <Link to="/report/product-rate-between-two-day">
                                                                Product rate Report  Between Two Day
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>

                                                    </ul>
                                                    <ul className="submenu">
                                                        <p style={this.styles.menuHeader}>Invoice</p>
                                                        <li onClick={this.hideSubMenu.bind(this, "product")}>
                                                            <a onClick={this.handleCreateInvoive.bind(this)}>
                                                                Create Invoice
                                                                <span className="line"></span>
                                                            </a>
                                                        </li>
                                                        <p style={this.styles.menuHeader}>Invoice Report </p>
                                                        <li onClick={this.hideSubMenu.bind(this, "product")}>
                                                            <Link to="/report/invoice-report-between-two-day">
                                                                Invoice report  Between Two Day
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                        <li onClick={this.hideSubMenu.bind(this, "product")}>
                                                            <Link to="/report/invoice-shortage-report-between-two-day">
                                                                Invoice Shortage report  Between Two Day
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                    </ul>

                                                    <ul className="submenu">
                                                        <p style={this.styles.menuHeader}>Dsr</p>
                                                        <li onClick={this.hideSubMenu.bind(this, "product")}>
                                                            <Link to="/page/last-inspection-entry">
                                                                Last Inspection Entry
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                        <li onClick={this.hideSubMenu.bind(this, "product")}>
                                                            <Link to="/report/dsr">
                                                                Dsr Report
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                        <li onClick={this.hideSubMenu.bind(this, "product")}>
                                                            <Link to="/page/instant-cash-memo">
                                                                Instant Cash Memo
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                    </ul>

                                                </div>
                                                <div style={{ height: "20px", background: "#23b9fd", alignSelf: "bottom", margin: "0 -20px" }}></div>
                                            </div>
                                        );
                                    }}
                                </Motion>
                            </li>
                            <li onMouseEnter={this.onMouseEnter.bind(this, "expenditure")} onClick={this.toggleSubmenu.bind(this, "expenditure")} onMouseLeave={this.onMouseLeave.bind(this, "expenditure")}  >
                                <i className="IconName" aria-hidden="true" title="expenditure">EXPENDITURE</i>
                                {/*----------------------- expenditure sub menu -------------------*/}
                                <Motion defaultStyle={{ x: 0 }} style={{ x: spring(this.state.submenus.expenditure ? 1 : 0, { stiffness: 150, damping: 15, precision: 1 }) }}>
                                    {({ x }) => {
                                        return (
                                            <div className="menuHolder"
                                                style={{
                                                    width: "850px",
                                                    height: `${x * 230}px`,
                                                    opacity: `${x}`,

                                                }}>
                                                <div style={{ display: "flex", flex: 1 }}>
                                                    <ul className="submenu">
                                                        <p style={this.styles.menuHeader}> New</p>
                                                        <li onClick={this.hideSubMenu.bind(this, "expenditure")}>
                                                            <Link to="/page/expenditure-detail">
                                                                Expenditure Entry
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                    </ul>
                                                    <ul className="submenu">
                                                        <p style={this.styles.menuHeader}>Report</p>
                                                        <li onClick={this.hideSubMenu.bind(this, "expenditure")}>
                                                            <Link to="/report/current-shift-expenditure">
                                                                Current Shift Expenditure  Report
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                        <li onClick={this.hideSubMenu.bind(this, "expenditure")}>
                                                            <Link to="/report/expenditure-between-two-day">
                                                                Expenditure Between two day
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                        <li onClick={this.hideSubMenu.bind(this, "expenditure")}>
                                                            <Link to="/report/expenditure-between-two-day-with-aggreagation">
                                                                Expenditure Between two day (grouped)
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div style={{ height: "20px", background: "#23b9fd", alignSelf: "bottom", margin: "0 -20px" }}></div>
                                            </div>
                                        );
                                    }}
                                </Motion>

                            </li>
                            <li onMouseEnter={this.onMouseEnter.bind(this, "shift")} onClick={this.toggleSubmenu.bind(this, "shift")} onMouseLeave={this.onMouseLeave.bind(this, "shift")} >
                                <i className="IconName" aria-hidden="true" title="shift">SHIFT</i>
                                {/*----------------------- SHIFT sub menu -------------------*/}
                                <Motion defaultStyle={{ x: 0 }} style={{ x: spring(this.state.submenus.shift ? 1 : 0, { stiffness: 150, damping: 15, precision: 1 }) }}>
                                    {({ x }) => {
                                        return (
                                            <div className="menuHolder"
                                                style={{
                                                    width: "850px",
                                                    height: `${x * 350}px`,
                                                    opacity: `${x}`,

                                                }}>
                                                <div style={{ display: "flex", flex: 1 }}>
                                                    <ul className="submenu">
                                                        <p style={this.styles.menuHeader}> New</p>
                                                        <li onClick={this.hideSubMenu.bind(this, "shift")}>
                                                            <Link to="/page/start-shift">
                                                                Start New Shift
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                        <li onClick={this.hideSubMenu.bind(this, "shift")}>
                                                            <Link to="/closeshift">
                                                                Close Shift
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                        <li onClick={this.hideSubMenu.bind(this, "shift")}>
                                                            <Link to="/page/employee-cash-collection">
                                                                Cash  Collect
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>

                                                        <li onClick={this.hideSubMenu.bind(this, "shift")}>
                                                            <Link to="/page/exchange">
                                                                Exchange  Entry
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>

                                                        <li onClick={this.hideSubMenu.bind(this, "shift")}>
                                                            <Link to="/page/stock-in">
                                                                Create Stock In
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                    </ul>
                                                    <ul className="submenu">
                                                        <p style={this.styles.menuHeader}>Report</p>

                                                        <li onClick={this.hideSubMenu.bind(this, "shift")}>
                                                            <Link to="/report/current-shift-cash-transaction">
                                                                Current Shift Cash Transaction
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                        <li onClick={this.hideSubMenu.bind(this, "shift")}>
                                                            <Link to="/report/close-shift-report-between-two-day">
                                                                Close Shift Report between two Day
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                        <li onClick={this.hideSubMenu.bind(this, "cash")}>
                                                            <Link to="/report/current-shift-cash-collection">
                                                                Current Shift Cash Collection
                                                                <span className="line"></span>
                                                            </Link>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div style={{ height: "20px", background: "#23b9fd", alignSelf: "bottom", margin: "0 -20px" }}></div>
                                            </div>
                                        );
                                    }}
                                </Motion>
                            </li>
                            {this.user.isAdmin ?
                                <li onMouseEnter={this.onMouseEnter.bind(this, "admin")} onClick={this.toggleSubmenu.bind(this, "admin")} onMouseLeave={this.onMouseLeave.bind(this, "admin")} >
                                    <i className="IconName" aria-hidden="true" title="admin">ADMIN</i>
                                    {/*-----------------------Admin sub menu -------------------*/}
                                    <Motion defaultStyle={{ x: 0 }} style={{ x: spring(this.state.submenus.admin ? 1 : 0, { stiffness: 150, damping: 15, precision: 1 }) }}>
                                        {({ x }) => {
                                            return (
                                                <div className="menuHolder"
                                                    style={{
                                                        width: "850px",
                                                        height: `${x * 430}px`,
                                                        opacity: `${x}`,

                                                    }}>
                                                    <div style={{ display: "flex", flex: 1 }}>
                                                        <ul className="submenu">
                                                            <li onClick={this.hideSubMenu.bind(this, "admin")}>
                                                                <Link to="/page/create-tank">
                                                                    Create new Tank
                                                                    <span className="line"></span>
                                                                </Link>
                                                            </li>
                                                            <li onClick={this.hideSubMenu.bind(this, "admin")}>
                                                                <Link to="/page/create-mpd">
                                                                    Create new Mpd
                                                                    <span className="line"></span>
                                                                </Link>
                                                            </li>
                                                            <li onClick={this.hideSubMenu.bind(this, "admin")}>
                                                                <Link to="/page/create-nozzel">
                                                                    Create new Nozzel
                                                                    <span className="line"></span>
                                                                </Link>
                                                            </li>
                                                            <li onClick={this.hideSubMenu.bind(this, "admin")}>
                                                                <Link to="/page/create-product">
                                                                    Create new Product
                                                                    <span className="line"></span>
                                                                </Link>
                                                            </li>
                                                            <li onClick={this.hideSubMenu.bind(this, "admin")}>
                                                                <Link to="/page/create-shift">
                                                                    Create new Shift
                                                                    <span className="line"></span>
                                                                </Link>
                                                            </li>
                                                            <li onClick={this.hideSubMenu.bind(this, "admin")}>
                                                                <Link to="/page/product-rate">
                                                                    Create rate
                                                                    <span className="line"></span>
                                                                </Link>
                                                            </li>
                                                            <li onClick={this.hideSubMenu.bind(this, "admin")}>
                                                                <Link to="/page/create-currency">
                                                                    Create new currency
                                                                    <span className="line"></span>
                                                                </Link>
                                                            </li>


                                                        </ul>
                                                        <ul className="submenu">
                                                            <li onClick={this.hideSubMenu.bind(this, "admin")}>
                                                                <Link to="/page/create-swipe">
                                                                    Create new Swipe Machines
                                                                    <span className="line"></span>
                                                                </Link>
                                                            </li>
                                                            <li onClick={this.hideSubMenu.bind(this, "admin")}>
                                                                <Link to="/page/create-expenditure">
                                                                    Create new Expenditure
                                                                    <span className="line"></span>
                                                                </Link>
                                                            </li>
                                                            <li onClick={this.hideSubMenu.bind(this, "admin")}>
                                                                <Link to="/page/create-transaction-account">
                                                                    Create Transaction Account
                                                                    <span className="line"></span>
                                                                </Link>
                                                            </li>
                                                            <li onClick={this.hideSubMenu.bind(this, "admin")}>
                                                                <Link to="/page/create-paymode">
                                                                    Create new Payment Mode
                                                                    <span className="line"></span>
                                                                </Link>
                                                            </li>
                                                            <li onClick={this.hideSubMenu.bind(this, "admin")}>
                                                                <Link to="/page/create-link-tr-paymode">
                                                                    TransactionAccount  link  to Payment Mode
                                                                    <span className="line"></span>
                                                                </Link>
                                                            </li>

                                                            <li onClick={this.hideSubMenu.bind(this, "admin")}>
                                                                <Link to="/page/create-user">
                                                                    Create User
                                                                    <span className="line"></span>
                                                                </Link>
                                                            </li>

                                                            <li onClick={this.hideSubMenu.bind(this, "admin")}>
                                                                <Link to="/page/send-msg">
                                                                    Send Message
                                                                    <span className="line"></span>
                                                                </Link>
                                                            </li>
                                                            <li onClick={this.hideSubMenu.bind(this, "admin")}>
                                                                <Link to="/page/msg-subscription">
                                                                    Message Subscription
                                                                    <span className="line"></span>
                                                                </Link>
                                                            </li>
                                                            <li onClick={this.hideSubMenu.bind(this, "admin")}>
                                                                <Link to="/report/msg-subscription-report">
                                                                    Message Subscription
                                                                    <span className="line"></span>
                                                                </Link>
                                                            </li>


                                                        </ul>
                                                        <ul className="submenu">
                                                            <p style={this.styles.menuHeader}>Edit</p>
                                                            <li onClick={this.hideSubMenu.bind(this, "admin")}>
                                                                <Link to="/page/user-edit">
                                                                    Edit User
                                                                    <span className="line"></span>
                                                                </Link>
                                                            </li>
                                                            <li onClick={this.hideSubMenu.bind(this, "admin")}>
                                                                <Link to="/page/mpd-nozzel-edit">
                                                                    Edit MPd-Nozzel
                                                                    <span className="line"></span>
                                                                </Link>
                                                            </li>
                                                            <li onClick={this.hideSubMenu.bind(this, "admin")}>
                                                                <Link to="/report/employee-pay-rate">
                                                                    UpDate Employee pay Rate
                                                                    <span className="line"></span>
                                                                </Link>
                                                            </li>
                                                            <p style={this.styles.menuHeader}>Report</p>
                                                            <li onClick={this.hideSubMenu.bind(this, "admin")}>
                                                                <Link to="/report/get-interest-report">
                                                                    Intrest Report
                                                                    <span className="line"></span>
                                                                </Link>
                                                            </li>
                                                            <p style={this.styles.menuHeader}>Shift</p>
                                                            <li onClick={this.hideSubMenu.bind(this, "admin")} >
                                                                <a onClick={this.handleUndoShift.bind(this)}>
                                                                    Undo Shift
                                                                    <span className="line"></span>
                                                                </a>
                                                            </li>
                                                            <li onClick={this.hideSubMenu.bind(this, "admin")}>
                                                                <Link to="/page/backward-stockin">
                                                                    BackWard StockIn
                                                                    <span className="line"></span>
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div style={{ height: "20px", background: "#23b9fd", alignSelf: "bottom", margin: "0 -20px" }}></div>
                                                </div>
                                            );
                                        }}
                                    </Motion>
                                </li>
                                : null
                            }
                        </ul>
                    </div>

                    <div className="rightMenuBar">
                        <div>
                            <ul>
                                <li onBlur={this.onSearchMouseLeave.bind(this)}>
                                    <i className="fa fa-search" style={{ Zindex: 1, fontSize: "20px", color: "white", marginTop: "8px" }} onClick={this.handleSearch} aria-hidden="true"></i>
                                    <div className="searchBar" style={{ display: "inline-block", marginTop: "9px" }}  >
                                        <AutoComplete
                                            class="mainSearch"
                                            placeholder="Search"
                                            dataSrc={this.state.allLinks}
                                            dataTobind="linkName"
                                            keyToBind="linkAddress"
                                            onSelect={this.seleteLink}
                                            tabIndex="1"
                                            clearStyle={{ display: "none", top: "5px", color: "white", fontSize: "14px" }}
                                            listStyle={{ fontSize: "16px" }}
                                            inputStyle={{ marginLeft: "20px", textTransform: "lowercase", fontSize: "16px", background: " rgb(35, 185, 253)", transition: "width 0.3s ease-in", transformOrigin: "center right", border: "none", padding: "0px", outline: "none", borderBottom: "2px solid #4291b5", borderRadius: "0", width: this.state.searchMode ? "300px" : "0" }}
                                            rex={(searchBox) => {
                                                this.searchBox = searchBox;
                                                //this.searchBox.onfocus = this.onSelectEmployeeFocus.bind(this);
                                            }}
                                        />
                                    </div>
                                </li>
                                {this.user.isAdmin ?
                                    <li onClick={this.handleAdminNotification.bind(this)} ><i className="fa fa-bell-o barIcon" aria-hidden="true"><span className="notificationNo">{notificationStore.getNoOfNotification()}</span></i></li>
                                    : null}
                                <li onClick={this.handleUserCard.bind(this)}><i className="fa fa-user barIcon" aria-hidden="true" title="Logout"></i></li>

                            </ul>
                        </div>
                    </div>
                    {this.userCard}
                    {this.stockIn}
                    {this.adminNotification}

                </div>
                <NetDetect />
            </div>
        );
    }
}



export default Master1;



// WEBPACK FOOTER //
// ./src/jsx/components/master/master1.jsx